import { useCycleList, useIntervalFn } from '@vueuse/core';
import type { Ref } from 'vue';
import { computed, watch } from 'vue';

export interface SpotlightTarget {
    element: HTMLElement | null;
    label: string;
}

const SPOTLIGHT_SWITCH_INTERVAL = 2000;

export function useSpotlightRotation(targets: Ref<SpotlightTarget[]>, isActive: Ref<boolean>) {
    const { state: target, index: targetIndex, next: showNextTarget } = useCycleList(targets);

    const { pause, resume } = useIntervalFn(showNextTarget, SPOTLIGHT_SWITCH_INTERVAL, { immediate: false });

    watch(isActive, (isRotating) => {
        targetIndex.value = 0;

        if (isRotating) {
            resume();
            return;
        }

        pause();
    }, { immediate: true });

    const currentTarget = computed(() => (isActive.value
        ? target.value ?? null
        : null));

    return { currentTarget };
}
